import request from '@/shared/api/request';

export const getKubernetesConfigFile = (uuid: string): Promise<Blob> =>
  request({
    url: `/kubernetes/${uuid}/kubeconfig/`,
    method: 'GET',
    responseType: 'blob',
  });
